import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar-dropdown"
export default class extends Controller {
  static targets = ["dropdown", "trigger", "notificationBadge", "chevron"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.dropdownTarget.classList.remove("hidden")
    
    // Rotate chevron if present (for user menu)
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.add("rotate-180")
    }
    
    // Hide notification badge if present
    if (this.hasNotificationBadgeTarget) {
      this.notificationBadgeTarget.classList.add("hidden")
    }
    
    // Add click outside listener
    setTimeout(() => {
      document.addEventListener("click", this.closeOnClickOutside)
    }, 0)
  }

  close() {
    this.isOpen = false
    this.dropdownTarget.classList.add("hidden")
    
    // Reset chevron if present
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove("rotate-180")
    }
    
    // Remove click outside listener
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }
}
